import React from 'react';
import { GridContainer, Grid } from '../../../shared/grid';
import '../FieldSample.scss';
import Button from '@mui/material/Button';
import { useStoreContext } from 'src/store/context';
import { createUpdateSample } from 'src/apis/mutationsFuelSample';
import { useAddAlert } from 'src/store/actions';
import { errorResponse } from 'src/store/common';
import { alertMessages } from 'src/constants';

type SubmitSampleProps = {
    setOpen: any,
    open: boolean,
    sampleToSubmit: any,
    setSampleToSubmit: any
}

export const Submit: React.FC<SubmitSampleProps> = ({ setOpen, open, sampleToSubmit, setSampleToSubmit }) => {
    const [, setState] = useStoreContext();
    const addAlert = useAddAlert(setState);

    const handleSampleSubmit = ()=>{
        (async()=>{
            try{
                const returnSample = await createUpdateSample(null, sampleToSubmit.sample, sampleToSubmit.setAddSampleCalled, true, addAlert);
                if(returnSample){
                    const callWasMade = {
                        ...sampleToSubmit,
                        submitCall: true
                    }
                    setSampleToSubmit(callWasMade)
                }
                setOpen(false);
            }   
            catch (error:any) {
                if (error?.toString()?.includes('duplicate')) {
                    errorResponse(error, addAlert, error);
                }
                else {
                    errorResponse(error, addAlert, alertMessages.fieldSampleSave);
                }
            }
        })();
    }
    return (
        <GridContainer className="removePadding">
            <Grid row gap="md" className='page-heading'>
                <Grid
                    desktop={{ col: 12 }}
                    className="display-flex flex-row flex-align-center flex-justify margin-bottom-205 paddingForModal">
                    {
                        <span className="font-sans-lg text-bold">Submit?</span>
                    }
                </Grid>
            </Grid>
            <hr style={{ width: '100%', marginBottom: 0 }}></hr>
            <Grid row className="paddingForm2">
              Are you sure you want to submit this item?
            </Grid>
            <Grid row className='modalBottomDiv'>
                <Grid desktop={{ col: 9 }} className="modalCancelDiv">
                    <Button variant="outlined" style={{ backgroundColor: 'white',textTransform: 'none' }} onClick={() => { setOpen(!open) }}>
                        Cancel
                    </Button>
                </Grid>
                <Grid desktop={{ col: 3 }} className='modalSubmitDiv'>
                    <Button variant="contained" type="submit" style={{textTransform: 'none'}} onClick={handleSampleSubmit}>
                        Submit
                    </Button>
                </Grid>
            </Grid>
        </GridContainer>
    )
}